import { defineStore } from 'pinia'

import { StoreId } from '@/store'

import { Success } from '@/api/results'
import { DeliveryMethods } from '@/types/api/api-v3/basket'
import { BasketPoint } from '@/types/api/api-v3/basket-points'
import { LoadState } from '@/types/main'
import { PointState } from '@/types/store/basket/points'

const defaultState: PointState = {
  data: [],
  isLoading: false,
  isLoaded: false,
  error: null,
}

export const useBasketPointStore = defineStore({
  id: StoreId.POINT,
  state: (): PointState => defaultState,
  actions: {
    async getPoints() {
      this.setPoints({ isLoading: true, isLoaded: false })

      const { $apiService } = useNuxtApp()
      const result = await $apiService.basket.getPoints()

      if (result instanceof Success) {
        this.setPoints({
          isLoading: false,
          isLoaded: true,
          ...result,
          error: null,
        })

        return
      }

      this.setPoints({ error: result })
    },
    // Метод проверки актуальности работы точки по установленному способу hall/pickup
    checkRelevanceOfPoint(
      currentPoint: BasketPoint,
      currentMethod: DeliveryMethods.PICKUP | DeliveryMethods.HALL,
    ) {
      const matchedPoint = this.$state.data.find(
        ({ id }) => id === currentPoint.id,
      )

      if (!matchedPoint) return !matchedPoint

      return matchedPoint[currentMethod] !== currentPoint[currentMethod]
    },

    setPoints(points: Partial<LoadState<BasketPoint[]>>) {
      Object.assign(this.$state, points)
    },
  },
  getters: {
    pickupPoints(state) {
      return state.data.filter((point) => point[DeliveryMethods.PICKUP])
    },

    hallPoints(state) {
      return state.data.filter((point) => point[DeliveryMethods.HALL])
    },
  },
})
